import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CompanyInfoModel } from '../../shared/models/company-info.model';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { CompanyService } from '../../shared/services/company.service';

interface FooterLink {
  label: string;
  route: string;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

@Component({
  selector: 'app-site-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, NzIconModule, TranslatePipe],
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
})
export class SiteFooterComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();
  readonly company = signal<CompanyInfoModel | null>(null);

  readonly columns: FooterColumn[] = [
    {
      title: 'Catalogue',
      links: [
        { label: 'Fabrics', route: '/fabrics' },
        { label: 'Collections', route: '/collections' },
        { label: 'Favorites', route: '/favorites' },
        { label: 'Sample request', route: '/cart' },
      ],
    },
    {
      title: 'Account',
      links: [
        { label: 'Profile', route: '/profile' },
        { label: 'Orders', route: '/orders' },
        { label: 'Quotations', route: '/quotations' },
        { label: 'Developments', route: '/development-requests' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', route: '/about' },
        { label: 'Contact Us', route: '/contact' },
        { label: 'FAQ', route: '/faq' },
      ],
    },
  ];

  constructor(private readonly companyService: CompanyService) {}

  ngOnInit(): void {
    this.companyService.getXfabrics().subscribe((company) => this.company.set(company));
  }
}
